import api from '@/apis/di/accountAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('account', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_account',
    field: {
      key: 'account_id',
      code: 'account_number',
      name: 'account_name',
      parentKey: 'parent_id',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};

const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
